/**
 * LinkedIn Insight Tag – conversion and CTA tracking.
 *
 * Use trackLinkedInConversion() when a user completes a conversion (e.g. sign-up,
 * form submit, CTA click). Conversion IDs are created in LinkedIn Campaign Manager
 * and should be provided by marketing.
 *
 * Example: trackLinkedInConversion(12345678);
 */

declare global {
  interface Window {
    lintrk?: (action: string, payload?: Record<string, unknown>) => void;
  }
}

/**
 * Fire a conversion or CTA event to LinkedIn.
 * Safe to call in SSR; no-op if lintrk is not loaded yet.
 */
export function trackLinkedInConversion(conversionId: number): void {
  if (typeof window === 'undefined' || !window.lintrk) return;
  window.lintrk('track', { conversion_id: conversionId });
}
